<template lang="pug">
v-container
  v-card.pointer(v-if="availableYears.length" v-for="item in availableYears" :key="item.id" class="mx-auto mb-1" max-width="400" @click.native="goNext(item)")
    v-card-title {{ item }}
      span.ellipse.mg-act( v-if="hasNewAct && notViewedMyAct.some(el => el.year == item)" )
</template>
<script>
import { mapState, mapActions } from "vuex";


export default {
  computed: {
    ...mapState("act", ['availableYears', 'notViewedMyAct']),

    hasNewAct() {
      return this.notViewedMyAct && this.notViewedMyAct.length
    }
  },

  beforeMount() {
    this.loadAvailableYears()
  },

  methods: {
    ...mapActions("act", ['loadAvailableYears']),
    goNext(item){
      this.$router.push(`/personalAccount/yearsAct/${item}/months`)
    },
  }
}
</script>
<style scoped>
.ellipse {
  height: 8px;
  width: 8px;
  border-radius: 4px;
  background-color: #ED0E51;
  position: relative;
  background-image: url(/src/layouts/img/red-circle.gif);
  background-size: cover;
}
.mg-act {
  margin-left: 5px;
  margin-bottom: 17px;
}
</style>